import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import uuid from 'uuid';

import { StaticVideo, VideoRef } from '../../../../../../../types/items';
import { ButtonGroup } from '../../../../../../../components';
import { selectMediaExport } from '../../../../../../../store/modules/articles/selectors';
import { addDownloadMedia } from '../../../../../../../store/modules/articles/actions';
import useStyles from '../styles';
import { getQuality } from '../../../utils';



const DownloadVideoAction = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { media } = useSelector(selectMediaExport);

  const clickHandler = useCallback((staticVideo: StaticVideo, video: VideoRef) => {
    return () => {
      if (video && staticVideo) {
        const ext = staticVideo.url.split('.').pop();
        const fileName = `${video.ref.filename_base}.${ext}`;
        dispatch(
          addDownloadMedia({
            url: staticVideo.url,
            name: fileName,
            downloadId: uuid(),
            urlRequested: false,
          }),
        );
      }
    };
  }, [dispatch]);

  if (media && media.ref.video) {
    const { video } = media.ref;
    if (video.ref.statics) {
      const buttons = video.ref.statics.map((item) => {
        return {
          title: 'Download',
          titleList: `Download ${getQuality(item.name)}`,
          onClick: clickHandler(item, video),
          disabled: false,
        };
      }).reverse();

      return (
        <ButtonGroup
          buttons={buttons}
          color="default"
          variant="text"
          className={classes.groupAction}
        />
      );
    }
  }

  return null;
};

export default DownloadVideoAction;
